import { Select } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import DateRange from "@/Components/common/client/createjob/selectDates/recurrence/DateRange";
import EveryFrequency from "@/Components/common/client/createjob/selectDates/recurrence/EveryFrequency";
import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";
import {
  toggleCustomRecurrenceModalOpen,
  updateJobData,
  updateJobShiftList,
  updateRecurrenceList,
  updateRepeatObj,
} from "@/reducers/clientcreatejob";
import { showErrorToast } from "@/utilities/utils";

const CustomDateRecurrenceModal = () => {
  const dispatch = useDispatch();
  const {
    jobData,
    repeatObj,
    recurringListingPresets: {
      frequencyPresets,
      weekDaysNamesPresets,
      monthsNamesPresets,
      daysOfWeekPresets,
    },
    customRecurrenceModalOpen,
  } = useSelector((state) => state.clientCreateJob);
  const [oldRepeatObj, setOldRepeatObj] = useState({});
  const handleClose = () => {
    dispatch(toggleCustomRecurrenceModalOpen(false));
  };
  useEffect(() => {
    if (customRecurrenceModalOpen) {
      setOldRepeatObj(repeatObj);
    }
  }, [customRecurrenceModalOpen]);

  const makeDateList = () => {
    if (repeatObj.startsOn === null) {
      showErrorToast("Please select a start date", {
        id: "startDateError",
      });
      return;
    }
    if (repeatObj.endsOn === null) {
      showErrorToast("Please select an end date", {
        id: "endDateError",
      });
      return;
    }
    if (repeatObj.dates.length === 0) {
      showErrorToast("Please select a date range", {
        id: "dateRangeError",
      });
      return;
    }
    let preserveObj = {
      repeat: repeatObj.repeat,
      frequency: repeatObj.frequency,
      everyFrequency: repeatObj.everyFrequency || 1,
      startsOn: repeatObj.startsOn || null,
      endsOn: repeatObj.endsOn || null,
      dates: repeatObj.dates || [],
      shiftOccurText: repeatObj.shiftOccurText || "",
      recurrenceWeekDays:
        repeatObj.frequency === "weekly" ? repeatObj.recurrenceWeekDays : [],
      recurrenceMonthDates:
        repeatObj.frequency === "monthly" ? repeatObj.recurrenceMonthDates : [],
      recurrenceYearDayOfWeek:
        repeatObj.frequency === "yearly"
          ? repeatObj.recurrenceYearDayOfWeek
          : ["First"],
      recurrenceYearWeekDay:
        repeatObj.frequency === "yearly"
          ? repeatObj.recurrenceYearWeekDay
          : ["Monday"],
      recurrenceYearMonths:
        repeatObj.frequency === "yearly"
          ? repeatObj.recurrenceYearMonths
          : ["January"],
    };
    dispatch(updateRepeatObj(preserveObj));
    let days = [];
    let jobShiftObj = [];
    let newSelectDatesRanges = repeatObj.dates.map((date) => {
      return [date, date];
    });
    dispatch(
      updateJobData({
        selectDatesRanges: newSelectDatesRanges,
        selectDateJobDates: repeatObj.dates,
        // startDate: null,
        // endDate: null,
      }),
    );
    repeatObj.dates.forEach((date) => {
      let day = moment(date, "DD-MM-YYYY").format("dddd");
      if (!days.includes(day)) {
        days.push(day);
      }
      let obj = {
        date: date,
        day: day,
        startTime: jobData.startTime,
        endTime: jobData.endTime,
        break: jobData.breakTime,
        admin: jobData.adminTime,
        rateName: "",
        rate: 0,
        total: 0,
        countDays: null,
        rate_values: [],
        clientPay: null,
      };
      jobShiftObj.push(obj);
    });
    dispatch(
      updateJobData({
        weekDays: days,
      }),
    );
    dispatch(updateJobShiftList(jobShiftObj));
    dispatch(toggleCustomRecurrenceModalOpen(false));
    setTimeout(() => {
      dispatch(
        updateJobData({
          startDate: repeatObj.startsOn,
          endDate: repeatObj.endsOn,
          fromRepeat: true,
        }),
      );
    }, 50);
  };
  return (
    <ModalPopUp
      show={customRecurrenceModalOpen}
      panelClass="max-w-[770px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="flex flex-col gap-4">
          <div className="flex justify-between">
            <h3 className="text-[20px] font-semibold leading-[normal] text-black">
              Custom Recurrence
            </h3>
            <button
              onClick={() => {
                handleClose();
              }}
              className="text-red outline-none ring-0"
            >
              <RejectIcon />
            </button>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div className="flex flex-col gap-3">
              <label className="label" htmlFor="jobTitle">
                Frequency
              </label>
              <Select
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Role"
                optionFilterProp="children"
                className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
                suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                onChange={(value) => {
                  dispatch(
                    updateRepeatObj({
                      // ...defaultRepeatObj,
                      frequency: value,
                      repeat: value,
                      // everyFrequency: 1,
                      // startsOn: repeatObj.startsOn,
                      // endsOn: repeatObj.endsOn,
                      // dates: repeatObj.dates,
                      // shiftOccurText: "",
                    }),
                  );
                  dispatch(updateRecurrenceList());
                  // setFieldValue("roleId", value);
                  // if (touched.roleId && errors.roleId) {
                  //   validateForm();
                  // }
                  // handleRoleChange(value);
                }}
                value={repeatObj.frequency}
              >
                {frequencyPresets.map((item, index) => {
                  const { label, value } = item;
                  return (
                    <Select.Option value={value} key={index}>
                      {label}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
            <EveryFrequency />
            {repeatObj.frequency === "weekly" ? (
              <div className="col-span-2 flex gap-[7px]">
                {weekDaysNamesPresets.map((item, index) => {
                  return (
                    <div
                      role="button"
                      key={index}
                      className={`text-12 flex items-center justify-center font-normal leading-[18px] ${
                        repeatObj.recurrenceWeekDays.includes(item)
                          ? "bg-primary text-white"
                          : "bg-lightblue text-primary"
                      } transition-linear h-[30px] flex-1 rounded-[4px]`}
                      onClick={() => {
                        let temp = repeatObj.recurrenceWeekDays;
                        dispatch(
                          updateRepeatObj({
                            recurrenceWeekDays: temp.includes(item)
                              ? temp.filter((i) => i !== item)
                              : temp.concat(item),
                          }),
                        );
                        dispatch(updateRecurrenceList());
                      }}
                    >
                      {item}
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
          {repeatObj.shiftOccurText ? (
            <p className="text-[14px] font-semibold leading-[20px] text-primary">
              {repeatObj.shiftOccurText}
            </p>
          ) : null}
          {repeatObj.frequency === "monthly" ? (
            <>
              <div className="grid max-w-[350px] border-collapse grid-cols-7">
                {_.range(1, 32).map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`flex aspect-square h-[50px] w-[50px] items-center justify-center text-[18px] font-medium leading-[40px]`}
                      role="button"
                      onClick={() => {
                        dispatch(
                          updateRepeatObj({
                            recurrenceMonthDates:
                              repeatObj.recurrenceMonthDates.includes(item)
                                ? repeatObj.recurrenceMonthDates.filter(
                                    (i) => i !== item,
                                  )
                                : repeatObj.recurrenceMonthDates.concat(item),
                          }),
                        );
                        dispatch(updateRecurrenceList());
                      }}
                    >
                      <span
                        className={`transition-linear h-[40px] w-[40px] rounded-lg text-center ${repeatObj.recurrenceMonthDates.includes(item) ? "bg-primary text-white" : "text-black"}`}
                      >
                        {item}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          ) : null}
          {repeatObj.frequency === "yearly" ? (
            <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
              <div className="grid gap-2">
                <label className="label" htmlFor="jobTitle">
                  On the
                </label>
                <Select
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                  className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
                  suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                  onChange={(value) => {
                    dispatch(
                      updateRepeatObj({
                        recurrenceYearDayOfWeek: value,
                      }),
                    );
                    dispatch(updateRecurrenceList());
                  }}
                  value={repeatObj.recurrenceYearDayOfWeek}
                  mode="multiple"
                >
                  {daysOfWeekPresets.map((item, index) => {
                    return (
                      <Select.Option value={item} key={index}>
                        {item}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
              <div className="grid gap-2">
                <label className="label" htmlFor="jobTitle">
                  Days
                </label>
                <Select
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                  className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
                  suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                  onChange={(value) => {
                    dispatch(
                      updateRepeatObj({
                        recurrenceYearWeekDay: value,
                      }),
                    );
                    dispatch(updateRecurrenceList());
                  }}
                  value={repeatObj.recurrenceYearWeekDay}
                  mode="multiple"
                >
                  {weekDaysNamesPresets.map((item, index) => {
                    return (
                      <Select.Option value={item} key={index}>
                        {item}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
              <div className="grid gap-2">
                <label className="label" htmlFor="jobTitle">
                  Of
                </label>
                <Select
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                  className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] font-medium leading-[normal] text-black transition-all duration-200 focus:border-primary"
                  suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
                  onChange={(value) => {
                    var sortedMonths = value.sort((a, b) => {
                      return (
                        monthsNamesPresets.indexOf(a) -
                        monthsNamesPresets.indexOf(b)
                      );
                    });
                    dispatch(
                      updateRepeatObj({
                        recurrenceYearMonths: sortedMonths,
                      }),
                    );
                    dispatch(updateRecurrenceList());
                  }}
                  value={repeatObj.recurrenceYearMonths}
                  mode="multiple"
                >
                  {monthsNamesPresets.map((item, index) => {
                    return (
                      <Select.Option value={item} key={index}>
                        {item}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
            </div>
          ) : null}
          <DateRange />
        </div>
        <div className="flex justify-end gap-5">
          <button
            type="button"
            className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-primary text-white hover:bg-none hover:text-primary"
            onClick={() => {
              makeDateList();
            }}
          >
            Apply
          </button>
          <button
            type="button"
            className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-none text-primary hover:bg-primary hover:text-white"
            onClick={() => {
              // dispatch(resetRepeatObj());
              let tempOldObj = _.cloneDeep(oldRepeatObj);
              delete tempOldObj.frequency;
              delete tempOldObj.repeat;
              dispatch(updateRepeatObj(tempOldObj));
              // handleUpdateRepeatObj()
              dispatch(updateRecurrenceList());
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default CustomDateRecurrenceModal;
